/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customer-addresses",
	props:{
		companyId:{
			default: null
		}
	},
	data() {
		return {
			billingAddress:null,
			shippingAddresses: [],
			canHaveShippingAddresses: false,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			customer: {},
			provinces: [],
			shippingAreas: [],
			shippingZones: [],
			shippingAddressHeadings: [
				{
					text: "Site Name",
					field: "siteName"
				},
				{
					text: "Street Address",
					field: "streetAddress"
				},
				{
					text: "City",
					field: "city"
				},
				{
					text: "Postal Code",
					field: "postalCode"
				},
				//TODO: add contact person
				// {
				// 	text: "Contact Person First Name",
				// 	field: "contactPersonFirstName"
				// },
				// {
				// 	text: "ContactPersonLastName",
				// 	field: "contactPersonLastName"
				// },
				// {
				// 	text: "Contact Person Phone Number",
				// 	field: "contactPersonPhoneNumber"
				// }
			],
			actions: [],
			actionKeys:{
				edit: "edit",
				delete: "delete"
			},
			shippingAddressFilter:{
				searchQuery: null,
				activeOrInactiveItems: 1
			},
			filterStateChanged: false,
			billingAddressModal:{
				showModal: false,
				isSaving: false,
				modalId: "billingAddressModal",
				heading: "Add Billing Address",
				billingAddress: {
					companyAddressId: null,
					companyId: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					siteName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					addressTypeId: 1,
					provinceId: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					streetAddress: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					city: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					postalCode: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					vatNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					}
				}
			},
			shippingAddressModal:{
				showModal: false,
				isSaving: false,
				modalId: "shippingAddressModal",
				heading: "Add Shipping Address",
				shippingAddress: {
					companyAddressId: null,
					companyId: null,
					siteName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					addressTypeId: 2,
					provinceId: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					streetAddress: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					suburb: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					city: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					postalCode: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					areaId: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					zoneId: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					gpsCoordinates:{
						value: null,
						hasError: false,
						errorMessage: null
					},
					latitude:{
						value: null,
						hasError: false,
						errorMessage: null
					},
					longitude:{
						value: null,
						hasError: false,
						errorMessage: null
					},
					contactPerson:{
						firstName: {
							value: null,
							hasError: false,
							errorMessage: null
						},
						lastName: {
							value: null,
							hasError: false,
							errorMessage: null
						},
						phoneNumber: {
							value: null,
							hasError: false,
							errorMessage: null
						}
					}
				}
			},
			shippingAddressMarkAsActiveOrInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveShippingAddressModal",
				heading: "Mark Shipping Address As Active/Inactive",
				isActive: null,
				companyAddressId: null
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			loadingBillingAddress: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getCustomer(){
			let request = {
				companyId: this.companyId
			};
			customerService.getCompany(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.customer = successResponse.data.result;
						this.shippingAddressModal.shippingAddress.siteName.value = this.customer.registeredCompanyName;
						this.canHaveShippingAddresses = this.customer.enableDeliveryOrders;
						this.setBreadcrumbs();
						this.getCustomerShippingAddresses();
						this.getCustomerBillingAddress();
					}
					permissionsHelper.setControlsBasedOnPermissions();
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerShippingAddresses(){
			this.loading = true;
			let request = {
				companyId: this.companyId,
				searchQuery: this.shippingAddressFilter.searchQuery,
				isActive: castingUtility.toBoolean(this.shippingAddressFilter.activeOrInactiveItems)
			};
			customerService.getCompanyShippingAddresses(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.shippingAddresses = successResponse.data.result;
						for(let i = 0; i < this.shippingAddresses.length; i++){
							this.shippingAddresses[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnEditShippingAddress"
								},
								{
									name: this.shippingAddresses[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.delete,
									elementId: "btnMarkAsActiveInactiveShippingAddress"
								}
							];
						}
						this.shippingAddresses = dataTableHelper.castFieldValues(this.shippingAddresses);
						this.filterStateChanged = false;
						
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerBillingAddress(){
			this.loadingBillingAddress = true;
			let request = {
				companyId: this.companyId
			};
			customerService.getCompanyBillingAddresses(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.result !== null && successResponse.data.result.length > 0){
							this.billingAddress = successResponse.data.result[0];
						}
						else{
							this.billingAddressModal.billingAddress.vatNumber.value = this.customer.taxVatNumber;
							this.billingAddressModal.billingAddress.siteName.value = this.customer.registeredCompanyName;
						}
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getProvinces(){
			systemService.getProvinces().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.provinces = successResponse.data.result;
						this.provinces = $.map(this.provinces,
							function (obj) {
								obj.id = obj.id || obj.provinceId;
								obj.text = obj.text || obj.description;
								return obj;
							});
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getShippingAreas(){
			let request = {
				isActive: true
			};
			let fieldsToFilterBy = [
				{
					value: null,
					key: "description"
				},
				// {
				// 	value: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				// 	key: "isActive"
				// }
			];
			let activeOnly = true;
			systemService.getShippingAreas(fieldsToFilterBy, request, false, activeOnly).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.shippingAreas = successResponse.data.result;
						this.shippingAreas = $.map(this.shippingAreas,
							function (obj) {
								obj.id = obj.id || obj.shippingAreaId;
								obj.text = obj.text || obj.description;
								return obj;
							});
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getShippingZones(){
			let request = {
				isActive: true
			};
			let fieldsToFilterBy = [
				{
					value: null,
					key: "description"
				},
				// {
				// 	value: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				// 	key: "isActive"
				// }
			];
			let activeOnly = true;
			systemService.getZones(fieldsToFilterBy, request, false, activeOnly).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.shippingZones = successResponse.data.result;
						this.shippingZones = $.map(this.shippingZones,
							function (obj) {
								obj.id = obj.id || obj.zoneId;
								obj.text = obj.text || obj.description;
								return obj;
							});
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			this.getCustomerShippingAddresses();	
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.shippingAddressFilter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onProvinceSelect(province, isShippngAddress){
			if(!isShippngAddress){
				this.billingAddressModal.billingAddress.provinceId.value = province.id;
			}
			else{
				this.shippingAddressModal.shippingAddress.provinceId.value = province.id;
			}
		},
		onAreaSelect(area){
			this.shippingAddressModal.shippingAddress.areaId.value = area.id;
		},
		onZoneSelect(zone){
			this.shippingAddressModal.shippingAddress.zoneId.value = zone.id;
		},
		onAddBillingAddressClick(){
			this.billingAddressModal.showModal = true;
			this.billingAddressModal.heading = "Add Billing Address";
		},
		onEditBillingAddressClick(){
			//set billing object to one used in form
			this.billingAddressModal.showModal = true;
			this.billingAddressModal.heading = "Edit Billing Address";
			this.billingAddressModal.billingAddress.companyAddressId = this.billingAddress.companyAddressId;
			this.billingAddressModal.billingAddress.streetAddress.value = this.billingAddress.streetAddress;
			this.billingAddressModal.billingAddress.city.value = this.billingAddress.city;
			this.billingAddressModal.billingAddress.vatNumber.value = this.billingAddress.vatNumber;
			this.billingAddressModal.billingAddress.postalCode.value = this.billingAddress.postalCode;
			this.billingAddressModal.billingAddress.provinceId.value = this.billingAddress.provinceId;
			this.billingAddressModal.billingAddress.siteName.value = this.billingAddress.siteName;
		},
		onShippingAddressAddClick(){
			this.shippingAddressModal.showModal = true;
			this.shippingAddressModal.heading = "Add Shipping Address";
			this.shippingAddressModal.shippingAddress.siteName.value = this.customer.registeredCompanyName;
		},
		onShippingAddressActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.shippingAddressModal.showModal = true;
					this.shippingAddressModal.heading = "Edit Shipping Address";
					this.shippingAddressModal.shippingAddress.streetAddress.value = actionAndData.data.streetAddress;
					this.shippingAddressModal.shippingAddress.city.value = actionAndData.data.city;
					this.shippingAddressModal.shippingAddress.postalCode.value = actionAndData.data.postalCode;
					this.shippingAddressModal.shippingAddress.contactPerson.firstName.value = actionAndData.data.contactFirstName;
					this.shippingAddressModal.shippingAddress.contactPerson.lastName.value = actionAndData.data.contactLastName;
					this.shippingAddressModal.shippingAddress.contactPerson.phoneNumber.value = actionAndData.data.contactPhoneNumber;
					this.shippingAddressModal.shippingAddress.companyAddressId = actionAndData.data.companyAddressId;
					this.shippingAddressModal.shippingAddress.provinceId.value = actionAndData.data.provinceId;
					this.shippingAddressModal.shippingAddress.areaId.value = actionAndData.data.shippingAreaId;
					this.shippingAddressModal.shippingAddress.zoneId.value = actionAndData.data.zoneId;
					this.shippingAddressModal.shippingAddress.siteName.value = actionAndData.data.siteName;
					let coordinates = actionAndData.data.gpsCoordinates.split(",");
					this.shippingAddressModal.shippingAddress.latitude.value = coordinates[0];
					this.shippingAddressModal.shippingAddress.longitude.value = coordinates[1];
					break;
				case this.actionKeys.delete:
					this.shippingAddressMarkAsActiveOrInactiveModal.showModal = true;
					this.shippingAddressMarkAsActiveOrInactiveModal.companyAddressId = actionAndData.data.companyAddressId;
					this.shippingAddressMarkAsActiveOrInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.shippingAddressMarkAsActiveOrInactiveModal.heading = "Mark Shipping Address As " + (this.shippingAddressMarkAsActiveOrInactiveModal.isActive ? "Inactive - " : "Active - ") + actionAndData.data.siteName;
					break;
			}
		},
		onBillingAddressModalCloseClick(){
			this.billingAddressModal.showModal = false;
		},
		onBillingAddressModalSaveButtonClicked(){
			this.billingAddressModal.isSaving = true;
			let request = {
				companyId: this.companyId,
				companyAddressId: this.billingAddressModal.billingAddress.companyAddressId,
				companyName: this.billingAddressModal.billingAddress.siteName.value,
				street: this.billingAddressModal.billingAddress.streetAddress.value,
				city: this.billingAddressModal.billingAddress.city.value,
				postalCode: this.billingAddressModal.billingAddress.postalCode.value,
				provinceId: this.billingAddressModal.billingAddress.provinceId.value === null ? 0 : this.billingAddressModal.billingAddress.provinceId.value,
				vatNumber: this.billingAddressModal.billingAddress.vatNumber.value,
			};
			customerService.addOrUpdateCustomerBillingAddress(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.customerBillingAddressValidationResponse.valuesAreValid) {
							this.clearBillingAddressModel();
							this.billingAddressModal.showModal = false;
							this.getCustomerBillingAddress();
						}
						else{
							this.billingAddressModal.billingAddress.siteName.hasError = successResponse.data.customerBillingAddressValidationResponse.companyNameValidationResponse.hasError;
							this.billingAddressModal.billingAddress.siteName.errorMessage = successResponse.data.customerBillingAddressValidationResponse.companyNameValidationResponse.message;
							
							this.billingAddressModal.billingAddress.streetAddress.hasError = successResponse.data.customerBillingAddressValidationResponse.streetValidationResponse.hasError;
							this.billingAddressModal.billingAddress.streetAddress.errorMessage = successResponse.data.customerBillingAddressValidationResponse.streetValidationResponse.message;
							
							this.billingAddressModal.billingAddress.city.hasError = successResponse.data.customerBillingAddressValidationResponse.cityValidationResponse.hasError;
							this.billingAddressModal.billingAddress.city.errorMessage = successResponse.data.customerBillingAddressValidationResponse.cityValidationResponse.message;
							
							this.billingAddressModal.billingAddress.postalCode.hasError = successResponse.data.customerBillingAddressValidationResponse.postalCodeValidationResponse.hasError;
							this.billingAddressModal.billingAddress.postalCode.errorMessage = successResponse.data.customerBillingAddressValidationResponse.postalCodeValidationResponse.message;
							
							this.billingAddressModal.billingAddress.provinceId.hasError = successResponse.data.customerBillingAddressValidationResponse.provinceValidationResponse.hasError;
							this.billingAddressModal.billingAddress.provinceId.errorMessage = successResponse.data.customerBillingAddressValidationResponse.provinceValidationResponse.message;
							
							this.billingAddressModal.billingAddress.vatNumber.hasError = successResponse.data.customerBillingAddressValidationResponse.vatNumberValidationResponse.hasError;
							this.billingAddressModal.billingAddress.vatNumber.errorMessage = successResponse.data.customerBillingAddressValidationResponse.vatNumberValidationResponse.message;
						}
					}
					this.billingAddressModal.isSaving = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.billingAddressModal.isSaving = false;
				}
			);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.shippingAddressMarkAsActiveOrInactiveModal.isSaving = true;
			let request = {
				companyAddressId: this.shippingAddressMarkAsActiveOrInactiveModal.companyAddressId,
				isActive: markAsActive,
				companyId: this.companyId
			};
			customerService.markCompanyAddressAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getCustomerShippingAddresses();
						this.shippingAddressMarkAsActiveOrInactiveModal.showModal = false;
						this.shippingAddressMarkAsActiveOrInactiveModal.isActive = true;
						this.shippingAddressMarkAsActiveOrInactiveModal.companyAddressId = null;
					}
					this.shippingAddressMarkAsActiveOrInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.shippingAddressMarkAsActiveOrInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onShippingAddressModalCloseClick(){
			this.shippingAddressModal.showModal = false;
			this.clearShippingAddressModel();
		},
		onShippingAddressModalSaveButtonClicked(){
			this.shippingAddressModal.isSaving = true;
			let request = {
				companyId: this.companyId,
				companyAddressId: this.shippingAddressModal.shippingAddress.companyAddressId,
				siteName: this.shippingAddressModal.shippingAddress.siteName.value,
				street: this.shippingAddressModal.shippingAddress.streetAddress.value,
				city: this.shippingAddressModal.shippingAddress.city.value,
				postalCode: this.shippingAddressModal.shippingAddress.postalCode.value,
				provinceId: this.shippingAddressModal.shippingAddress.provinceId.value === null ? 0 : this.shippingAddressModal.shippingAddress.provinceId.value,
				firstName: this.shippingAddressModal.shippingAddress.contactPerson.firstName.value,
				lastName: this.shippingAddressModal.shippingAddress.contactPerson.lastName.value,
				phoneNumber: this.shippingAddressModal.shippingAddress.contactPerson.phoneNumber.value,
				suburb: this.shippingAddressModal.shippingAddress.suburb.value,
				//areaId: this.shippingAddressModal.shippingAddress.areaId.value === null ? 0 : this.shippingAddressModal.shippingAddress.areaId.value,
				zoneId: this.shippingAddressModal.shippingAddress.zoneId.value === null ? 0 : this.shippingAddressModal.shippingAddress.zoneId.value,
				latitude: this.shippingAddressModal.shippingAddress.latitude.value,
				longitude: this.shippingAddressModal.shippingAddress.longitude.value,
			};
			customerService.addOrUpdateCustomerShippingAddress(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.customerShippingAddressValidationResponse.valuesAreValid) {
							this.clearShippingAddressModel();
							this.shippingAddressModal.showModal = false;
							this.getCustomerShippingAddresses();
						}
						else{
							this.shippingAddressModal.shippingAddress.contactPerson.firstName.hasError = successResponse.data.customerShippingAddressValidationResponse.firstNameValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.contactPerson.firstName.errorMessage = successResponse.data.customerShippingAddressValidationResponse.firstNameValidationResponse.message;
							
							this.shippingAddressModal.shippingAddress.contactPerson.lastName.hasError = successResponse.data.customerShippingAddressValidationResponse.lastNameValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.contactPerson.lastName.errorMessage = successResponse.data.customerShippingAddressValidationResponse.lastNameValidationResponse.message;
							
							this.shippingAddressModal.shippingAddress.contactPerson.phoneNumber.hasError = successResponse.data.customerShippingAddressValidationResponse.phoneNumberValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.contactPerson.phoneNumber.errorMessage = successResponse.data.customerShippingAddressValidationResponse.phoneNumberValidationResponse.message;
							
							this.shippingAddressModal.shippingAddress.siteName.hasError = successResponse.data.customerShippingAddressValidationResponse.siteNameValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.siteName.errorMessage = successResponse.data.customerShippingAddressValidationResponse.siteNameValidationResponse.message;
							
							this.shippingAddressModal.shippingAddress.streetAddress.hasError = successResponse.data.customerShippingAddressValidationResponse.streetValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.streetAddress.errorMessage = successResponse.data.customerShippingAddressValidationResponse.streetValidationResponse.message;
							
							this.shippingAddressModal.shippingAddress.city.hasError = successResponse.data.customerShippingAddressValidationResponse.cityValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.city.errorMessage = successResponse.data.customerShippingAddressValidationResponse.cityValidationResponse.message;
							
							this.shippingAddressModal.shippingAddress.postalCode.hasError = successResponse.data.customerShippingAddressValidationResponse.postalCodeValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.postalCode.errorMessage = successResponse.data.customerShippingAddressValidationResponse.postalCodeValidationResponse.message;
							
							this.shippingAddressModal.shippingAddress.provinceId.hasError = successResponse.data.customerShippingAddressValidationResponse.provinceValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.provinceId.errorMessage = successResponse.data.customerShippingAddressValidationResponse.provinceValidationResponse.message;
							
							// this.shippingAddressModal.shippingAddress.suburb.hasError = successResponse.data.customerShippingAddressValidationResponse.suburbValidationResponse.hasError;
							// this.shippingAddressModal.shippingAddress.suburb.errorMessage = successResponse.data.customerShippingAddressValidationResponse.suburbValidationResponse.message;
							
							this.shippingAddressModal.shippingAddress.areaId.hasError = successResponse.data.customerShippingAddressValidationResponse.areaValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.areaId.errorMessage = successResponse.data.customerShippingAddressValidationResponse.areaValidationResponse.message;
							
							this.shippingAddressModal.shippingAddress.zoneId.hasError = successResponse.data.customerShippingAddressValidationResponse.zoneValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.zoneId.errorMessage = successResponse.data.customerShippingAddressValidationResponse.zoneValidationResponse.message;
							
							this.shippingAddressModal.shippingAddress.latitude.hasError = successResponse.data.customerShippingAddressValidationResponse.latitudeValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.latitude.errorMessage = successResponse.data.customerShippingAddressValidationResponse.latitudeValidationResponse.message;
							
							this.shippingAddressModal.shippingAddress.longitude.hasError = successResponse.data.customerShippingAddressValidationResponse.longitudeValidationResponse.hasError;
							this.shippingAddressModal.shippingAddress.longitude.errorMessage = successResponse.data.customerShippingAddressValidationResponse.longitudeValidationResponse.message;
						}
					}
					this.shippingAddressModal.isSaving = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.shippingAddressModal.isSaving = false;
				}
			);
		},
		onFormModalSaveButtonClicked(){
			//save
			this.customerAddEditFormModal.isSaving = true;
			var self = this;
			setTimeout(function(){
				self.customerAddEditFormModal.isSaving = false;
				self.customerAddEditFormModal.showModal = false;
				console.log("customer", self.customer);
			}, 2000);
		},
		clearShippingAddressModel() {
			this.shippingAddressModal.shippingAddress = {
				companyAddressId: null,
				companyId: null,
				siteName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				addressTypeId: 2,
				provinceId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				streetAddress: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				suburb: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				city: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				postalCode: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				areaId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				zoneId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				gpsCoordinates:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				latitude:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				longitude:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				contactPerson:{
					firstName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					lastName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					phoneNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					}
				}
			};
		},
		clearBillingAddressModel() {
			this.billingAddressModal.billingAddress = {
				companyAddressId: null,
					companyId: {
					value: null,
						hasError: false,
						errorMessage: null
				},
				siteName: {
					value: null,
						hasError: false,
						errorMessage: null
				},
				addressTypeId: 1,
					provinceId: {
					value: null,
						hasError: false,
						errorMessage: null
				},
				streetAddress: {
					value: null,
						hasError: false,
						errorMessage: null
				},
				city: {
					value: null,
						hasError: false,
						errorMessage: null
				},
				postalCode: {
					value: null,
						hasError: false,
						errorMessage: null
				},
				vatNumber: {
					value: null,
						hasError: false,
						errorMessage: null
				}
			};
		},
		setBreadcrumbs() {
			var pageTitle = "Customer Addresses - " + this.customer.registeredCompanyName;
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.getProvinces();
		this.getShippingAreas();
		this.getShippingZones();
	},
	watch:{
		companyId:{
			handler: function () {
				console.log("companyId", this.companyId);
				if (this.companyId !== null && this.companyId > 0) {
					this.getCustomer();
				}
			},
			immediate: true,
			deep: true
		}
	}
};